// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ThankYou.css */

.thankyoucontainer {
    text-align: center;
    margin-top: 50px;
}
  
.thankyoucontainer h1 {
    font-size: 2em;
    color: #333;
}

.thankyoucontainer p {
    font-size: 1.2em;
    color: #666;
    margin-top: 20px;
}
  `, "",{"version":3,"sources":["webpack://./src/components/Logout/index.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB","sourcesContent":["/* ThankYou.css */\r\n\r\n.thankyoucontainer {\r\n    text-align: center;\r\n    margin-top: 50px;\r\n}\r\n  \r\n.thankyoucontainer h1 {\r\n    font-size: 2em;\r\n    color: #333;\r\n}\r\n\r\n.thankyoucontainer p {\r\n    font-size: 1.2em;\r\n    color: #666;\r\n    margin-top: 20px;\r\n}\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
